export default __webpack_public_path__ + "static/media/javascript.a63e0a46.png";